export type RevealState = 'draft' | 'scheduled' | 'revealed'

export type RevealMetadata = {
  id: string
  state: RevealState
  publicTeaser: string
  scheduledFor: string | null
}

export type RevealSecret = {
  title: string
  detail?: string
  imageUrl?: string
}

export type RevealView =
  | { state: 'draft'; teaser: string }
  | { state: 'scheduled'; teaser: string; scheduledFor: string }
  | { state: 'next_connection'; teaser: string }
  | { state: 'revealed'; teaser: string; title: string; detail?: string; imageUrl?: string }

export function getRevealView(
  metadata: RevealMetadata,
  authorizedSecret: RevealSecret | null,
  authoritativeNow: Date,
  online: boolean,
): RevealView {
  if (metadata.state === 'revealed' && authorizedSecret) {
    return {
      state: 'revealed',
      teaser: metadata.publicTeaser,
      title: authorizedSecret.title,
      ...(authorizedSecret.detail ? { detail: authorizedSecret.detail } : {}),
      ...(authorizedSecret.imageUrl ? { imageUrl: authorizedSecret.imageUrl } : {}),
    }
  }
  const due = metadata.scheduledFor !== null && authoritativeNow.getTime() >= Date.parse(metadata.scheduledFor)
  if (metadata.state === 'scheduled' && due && !online) {
    return { state: 'next_connection', teaser: metadata.publicTeaser }
  }
  if (metadata.state === 'scheduled' && metadata.scheduledFor) {
    return { state: 'scheduled', teaser: metadata.publicTeaser, scheduledFor: metadata.scheduledFor }
  }
  return { state: 'draft', teaser: metadata.publicTeaser }
}
